import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import autoBind from 'react-autobind';
import queryString from 'query-string';
import { reportOrders } from '../../actions';
import DatePicker from 'material-ui/DatePicker';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { CSVLink } from 'react-csv';
import FontIcon from 'material-ui/FontIcon';

const propTypes = {
  dispatch: PropTypes.func,
  locationSearch: PropTypes.object,
};

const optionsStyle = {
  maxWidth: 255,
  marginRight: 'auto',
};
const style = {
  margin: 12,
};

class ShowReporting extends Component {
  constructor(props) {
    super(props);
    const minDateInit = new Date();
    const maxDateInit = new Date();
    minDateInit.setDate(minDateInit.getDate() - 7);
    minDateInit.setHours(0, 0, 0, 0);
    maxDateInit.setHours(23, 59, 59, 59);
    const values = queryString.parse(this.props.locationSearch);
    this.state = {
      minDate: (values && values.fromDate) ? values.fromDate : `${minDateInit.getFullYear()}-${minDateInit.getMonth() + 1}-${minDateInit.getDate()}`,
      fromDateObj: (values && values.fromDate) ? new Date(values.fromDate) : minDateInit,
      maxDate: (values && values.toDate) ? values.toDate : `${maxDateInit.getFullYear()}-${maxDateInit.getMonth() + 1}-${maxDateInit.getDate()}`,
      toDateObj: (values && values.toDate) ? new Date(values.toDate) : maxDateInit,
      autoOk: false,
      disableYearSelection: false,
      value: 'orders',

    };
    autoBind(this);
  }

  handleGetReport() {
    return this.props.dispatch(reportOrders(this.state.minDate, this.state.maxDate, this.state.value));
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  handleChange(event, index, val){
    this.setState({value: val});
  }

  renderDownload() {
    if (this.props && this.props.report && this.props.report.length) {
      const iconStyles = {
        marginRight: 14,
      };
      return (
        <div>
          <FontIcon className="fa fa-download" style={iconStyles} />
          <CSVLink data={this.props.report} >Download Report</CSVLink>
        </div>
      )
    } else {
      return null;
    }
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <h2>Reporting</h2>
        <div className="content">
          <div style={optionsStyle}>
            <DatePicker
              value={this.state.fromDateObj}
              onChange={(event, date) => {
                const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                this.setState({ fromDateObj: date, minDate: dateString });
              }}
              autoOk={this.state.autoOk}
              floatingLabelText="From Date"
              defaultDate={this.state.fromDateObj}
              disableYearSelection={this.state.disableYearSelection}
            />
            <DatePicker
              value={this.state.toDateObj}
              onChange={(event, date) => {
                const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                this.setState({ toDateObj: date, maxDate: dateString });
              }}
              autoOk={this.state.autoOk}
              floatingLabelText="To Date"
              defaultDate={this.state.toDateObj}
              disableYearSelection={this.state.disableYearSelection}
            />
            <SelectField
              floatingLabelText="Submission Type"
              value={this.state.value}
              onChange={this.handleChange}
            >
              <MenuItem value='orders' primaryText="Orders Report" />
              <MenuItem value='orderItems' primaryText="Order Items" />
              <MenuItem value='uploadSubmissions' primaryText="Upload Submissions" />
              <MenuItem value='emailSubmissions' primaryText="Email Submissions" />
              <MenuItem value='shippedOrders' primaryText="Shipped Orders" />
            </SelectField>
            <RaisedButton label="Submit"
              onClick={this.handleGetReport}
              style={style}
              primary
            />
            {this.renderDownload()}
          </div>
        </div>
      </div>
    );
  }
}
ShowReporting.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowReporting.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    locationSearch: ownProps.location.search,
    report: (state.orders && state.orders.report) ? state.orders.report : {}
  };
}

export default withRouter(connect(mapStateToProps)(ShowReporting));


// WEBPACK FOOTER //
// ./src/components/Reporting/ShowReporting.js